import React from 'react';
import { Route } from 'react-router';
import App from './components/app';
import Invite from './containers/inviteContainer';
import Comment from './containers/commentContainer';
import Appreciate from './containers/appreciateContainer';

export default function(basePath) {
  return (
    <Route path="/" component={App}>
      <Route path={`${basePath}/invites/:accountInfo`} component={Invite} />
      <Route path={`${basePath}/thanks`} component={Appreciate} />
      <Route path={`${basePath}/:accountInfo`} component={Comment} />
    </Route>
  );
}
